import * as ActionTypes from '../../actionTypes/cabinListActionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.INIT_SUCCESS:
    case ActionTypes.INIT_FAIL:
      return action.labels;
    default:
      return state;
  }
};